import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import UserGemsService from "./user.gems.service";
import { GEMS } from "./gems";

export default class AutomatedTasksService extends ApiService {
  namespace = "automated-task";
  relations =
    "?expand=responsibleSimple,peopleSimple,files,files.file,files.file.commentsCount,completedByName";
  icon = "TaskList";

  singular = this.terminology.automatedTask.singular;
  plural = this.terminology.automatedTask.plural;
  vowel = this.terminology.automatedTask.vowel;
  enableSchedular = true;
  name = this.singular;
  favicon = "ClipboardWithTasks";
  Width = 1200;
  DOMAIN = 304;
  action = "action";
  gemItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: PrimeIcons.LIST,
    },
  ];
  columns = [
    {
      header: this.t("taskName"),
      icon: "Shred",
      field: "display_name",
    },
    {
      header: this.t("completedBy"),
      icon: "UserSilhouette",
      field: "completed_by",
    },
    {
      header: this.t("reminder"),
      icon: "GreenCalendar",
      field: "reminder_date",
    },
    {
      header: this.t("due"),
      icon: "Calendar",
      field: "due_date",
    },
    {
      header: this.t("responsible"),
      icon: "People",
      field: "responsebleSimple",
    },
    {
      header: this.t("people"),
      icon: "People",
      field: "peopleSimple",
    },
    {
      header: this.t("status"),
      icon: "Lightning",
      field: "status",
      width: "3",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit " + this.name,
      icon: "edit",
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Add an Automated Task",
      icon: PrimeIcons.LIST,
      domain: this.DOMAIN,
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
  ];

  permissions = GEMS.map((gem) => {
    return {
      key: gem.title.replace(/[: ]/g, "_").toLowerCase(),
      display_name: gem.title,
      icon: "Calculator",
      value: gem.id,
    };
  });

  constructor() {
    super("automated-tasks");
  }
}
